// projects/humanresources-personnel/src/assets/i18n/*/hr-per-edu-inst-faculty.json
export class HrPerEduInstFacultyKey {
    private static readonly keyPrefix = 'hrPerEduInstFaculty';
    public static facultyName = `${HrPerEduInstFacultyKey.keyPrefix}.facultyName`;
    public static institution = `${HrPerEduInstFacultyKey.keyPrefix}.institution`;
    public static faculty = `${HrPerEduInstFacultyKey.keyPrefix}.faculty`;
}
